import { buildActivityLogDetailRows } from "./activityLogDetail";

export const DCO_ACTIVITY_STEPS = [
  {
    id: 1,
    label: "Document Submission",
    slaDays: 1,
    aliases: ["Documents Uploading", "Application Submitted"],
  },
  {
    id: 2,
    label: "Document Verification",
    slaDays: 1,
    aliases: ["Documents Verification", "Documents Objection"],
  },
  {
    id: 3,
    label: "Arrear Verification",
    slaDays: 1,
    aliases: ["Arrears Verification"],
  },
  {
    id: 4,
    label: "Remove Meter Readings",
    slaDays: 1,
    aliases: ["Removed Meter Readings", "Remove Meter Reading"],
  },
  { id: 5, label: "Authority Decision", slaDays: 1 },
  {
    id: 6,
    label: "M&T Report Submission",
    slaDays: 1,
    aliases: ["M&T Report"],
  },
  {
    id: 7,
    label: "Forward To RO",
    slaDays: 1,
    aliases: ["Forward to RO"],
  },
  { id: 8, label: "Post For Billing", slaDays: 1 },
  { id: 9, label: "Completed", slaDays: 1 },
];

export function buildDcoActivityLogDetailRows(
  historyItems = [],
  currentStatus = {},
  formatDateFn,
) {
  return buildActivityLogDetailRows(historyItems, currentStatus, formatDateFn, {
    steps: DCO_ACTIVITY_STEPS,
    stepNameField: "dcoProgStatusName",
  });
}
